import { SECTIONS, TEST_TECH, WAITINGROOM } from './constants';

import {
	techSteps,
	sectionsSteps,
	introStep,
	outroStep,
	requisiteStep,
	waitingRoom,
	finished,
	blocked,
	notinterested,
	surveyStep,
} from './templateData';

/**
 * Build your app, and load the actual template here
 * @param {boolean} hasProctoring
 * @param {boolean} hasVideoAnswers
 * @param {boolean} hasRequisites
 * @param {boolean} testTechniqueOk - very important to load the correct technical template
 * @param {boolean} needRequisite
 * @param {Landing} landing
 * @param {boolean} isSessionCampaign
 * @param {boolean} alreadyOnSurveyStep
 * @param {boolean} survey
 * @param {Object} outro
 * @param {Object} steps for explain template
 * @returns {{template: {new: TemplateWorkflow[], blocked: [TemplateWorkflow], validated: ([TemplateWorkflow, TemplateWorkflow]|[TemplateWorkflow]), joined: TypeTemplate[], invited: TypeTemplate[], started: TypeTemplate[], finished: ([TemplateWorkflow, TemplateWorkflow]|[TemplateWorkflow]), notinterested: [TemplateWorkflow], entered: *, evaluated: ([{TemplateWorkflow,TemplateWorkflow]|[TemplateWorkflow])}, actualStepLoader: {new: string, blocked: string, validated: string, joined: string, invited: string, started: (string), finished: string, notinterested: string, entered: TypeTemplate, evaluated: string}}}
 */
export default ({
	hasVideoAnswers = false,
	hasProctoring = false,
	landing,
	hasRequisites = false,
	isSessionCampaign,
	alreadyOnSurveyStep = false,
	survey = false,
	outro,
	testTechniqueOk = false,
	needRequisite = false,
	steps,
}) => {
	const technicalSteps = techSteps({ hasVideoAnswers, steps, hasProctoring });

	/**
	 *
	 * @param {boolean} withWaitingRoom
	 * @param {boolean} survey
	 * @return {TemplateWorkflow[]}
	 */
	const totalFlowRaw = (withWaitingRoom = false, survey = false) => [
		introStep(landing),
		...[
			...technicalSteps,
			...(withWaitingRoom ? waitingRoom : []),
			...sectionsSteps({ hasRequisites, outro }),
			...(survey ? [surveyStep] : []),
		],
	];

	/**
	 * Waiting Room Tempalte is only added when there is video or proctoring.
	 * @type {boolean}
	 */
	const addWaitingRoomCondition = isSessionCampaign && (hasVideoAnswers || hasProctoring);
	/**
	 * All the classic workflow of the Exam App
	 */
	const totalWorkFlow = totalFlowRaw(addWaitingRoomCondition, survey);

	/**
	 *
	 * @type {TemplateWorkflow[]}
	 */
	const endFLow = alreadyOnSurveyStep
		? [surveyStep]
		: [
				...(needRequisite ? [requisiteStep, outroStep(outro)] : finished),
				...(survey ? [surveyStep] : []),
		  ];

	return {
		template: {
			notinterested,
			blocked,
			new: totalWorkFlow,
			joined: totalWorkFlow,
			invited: totalWorkFlow,
			entered: totalWorkFlow,
			started: totalWorkFlow,
			finished: endFLow,
			evaluated: endFLow,
			validated: endFLow,
		},
		actualStepLoader: {
			notinterested: 'fromStart',
			blocked: 'fromStart',
			new: 'fromStart',
			joined: 'fromStart',
			invited: 'fromStart',
			entered:
				addWaitingRoomCondition && testTechniqueOk
					? WAITINGROOM
					: testTechniqueOk
					? SECTIONS
					: TEST_TECH,
			started: (hasVideoAnswers || hasProctoring) && !testTechniqueOk ? TEST_TECH : SECTIONS,
			finished: 'fromStart',
			evaluated: 'fromStart',
			validated: 'fromStart',
		},
	};
};
